import { httpClient } from "../../httpClient";
import { ApproverDistro } from "../../../store";

type Payload = {
  id: number;
  name: string;
  isActive: boolean;
};

type MemberPayload = {
  approverDistroId: number;
  email: string;
};

type Data = any;

const approverDistroApi = "/api/v1/approverdistro";

export async function getApproverDistro(): Promise<any> {
  try {
    const { data } = await httpClient.get(approverDistroApi);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getMemberByApproverId(id: number): Promise<any> {
  try {
    const { data } = await httpClient.get(`${approverDistroApi}/members/${id}`);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function postApproverDistro(payload: Payload): Promise<any> {
  try {
    const { data } = await httpClient.post<Data>(approverDistroApi, payload);

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function postApproverDistroMember(
  payload: MemberPayload
): Promise<any> {
  try {
    const { data } = await httpClient.post(
      `${approverDistroApi}/member`,
      payload
    );

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function editApproverDistro(
  id: number,
  payload: Payload
): Promise<boolean> {
  try {
    const response = await httpClient.put(
      `${approverDistroApi}/${id}`,
      payload
    );

    return response.status === 200;
  } catch (error) {
    throw error;
  }
}

export async function deleteApproverDistroMemberById(id: number): Promise<any> {
  try {
    const { data } = await httpClient.delete(
      `${approverDistroApi}/member/${id}`
    );

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export const approverDistro = {
  postApproverDistro,
  editApproverDistro,
  getApproverDistro,
  getMemberByApproverId,
  postApproverDistroMember,
  deleteApproverDistroMemberById,
};
